var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 3C3.16789 3 3 3.16789 3 3.375V14.625C3 14.8321 3.16789 15 3.375 15H14.625C14.8321 15 15 14.8321 15 14.625V11.0526C15 10.6384 15.3358 10.3026 15.75 10.3026C16.1642 10.3026 16.5 10.6384 16.5 11.0526V14.625C16.5 15.6606 15.6606 16.5 14.625 16.5H3.375C2.33948 16.5 1.5 15.6606 1.5 14.625V3.375C1.5 2.33947 2.33947 1.5 3.375 1.5H6.75C7.16421 1.5 7.5 1.83579 7.5 2.25C7.5 2.66421 7.16421 3 6.75 3H3.375ZM15 4.06055V8.25C15 8.66421 15.3358 9 15.75 9C16.1642 9 16.5 8.66421 16.5 8.25V2.25C16.5 1.83579 16.1642 1.5 15.75 1.5H9.75C9.33579 1.5 9 1.83579 9 2.25C9 2.66421 9.33579 3 9.75 3H13.9392L9.1446 7.79464C8.8517 8.08753 8.8517 8.5624 9.1446 8.8553C9.43749 9.14819 9.91236 9.14819 10.2053 8.8553L15 4.06055Z",
    fill: "#002979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutLink);
export default __webpack_public_path__ + "static/media/out-link.4b9f06ca7e3a0c98684b7ef1c555c0ce.svg";
export { ForwardRef as ReactComponent };